import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login.vue';
import ChoicePage from '../components/ChoicePage.vue';
import DigitalH5Code from '../components/DigitalH5Code.vue';
import SayPage from '../components/SayPage.vue';


Vue.use(VueRouter);

const routes = [

  { path: '/login', 
  component: Login,
  name:"Login"
  },
  {
    path: '/code', 
    component: DigitalH5Code, 
    name:"code"
  },
  {
    path: '/say', 
    component: SayPage, 
    name:"say"
  },
  {
    path:"/choice",
    name:"choice",
    component:ChoicePage
  },
];




const router = new VueRouter({
  // mode: 'history',
  routes
});


export default router;